document.addEventListener("DOMContentLoaded", function () {
    setTimeout(() => {
        document.querySelectorAll(".Collection_testimonial_slider").forEach(slider => {
            new Swiper(slider, {
                pagination: {
                    el: slider.querySelector(".swiper-pagination"),
                    clickable: true
                }
            });
        });
    }, 300);
});